/**
 * Fit Live — flags de UI (módulo independiente).
 * Backend: FIT_LIVE_ENABLED · Frontend build: VITE_FIT_LIVE_ENABLED
 */
export function isFitLiveUiEnabled() {
  try {
    const v = import.meta.env?.VITE_FIT_LIVE_ENABLED;
    return String(v || '').toLowerCase() === 'true';
  } catch {
    return false;
  }
}

/** Cliente/coach Training: no debe caer en marketplace Fit Live (cualquier host). */
export function isTrainingShellUser(user) {
  if (!user) return false;
  const roles = [user.rol, ...(Array.isArray(user.roles) ? user.roles : [])].filter(Boolean);
  if (roles.includes('super_admin')) return false;
  if (String(user.entry_host || '').toLowerCase() === 'training') return true;
  if (user.coach_branding?.white_label_enabled === true) return true;
  if (roles.includes('entrenador') || roles.includes('admin_training') || roles.includes('admin_entrenador')) {
    return true;
  }
  const access = user.module_access || user.moduleAccess || {};
  const training = Boolean(access.training);
  const liveGym = Boolean(access.d28d || access.live_classes || access.gym);
  return training && !liveGym;
}

export function isTrainingPublicHost(hostname) {
  const host = String(hostname || (typeof window !== 'undefined' ? window.location.hostname : ''))
    .replace(/^www\./, '')
    .toLowerCase();
  if (host.startsWith('training.')) return true;
  if (typeof window !== 'undefined' && window.location.port === '3004') return true;
  return false;
}

export const ECOSISTEMA_FIT_LOGO = '/ecosistema-fit-logo.png';
export const ECOSISTEMA_FIT_FAVICON = '/favicon-ecosistema-fit.png';

function hasFitLiveCreatorFlag(user) {
  const access = user?.module_access && typeof user.module_access === 'object' ? user.module_access : {};
  return access.fit_live_creator === true || access.fitlive_creator === true;
}

/** Creator Studio + Control Tower (gestión). Super admin o flag fit_live_creator. */
export function canManageFitLiveStudio(user) {
  if (!isFitLiveUiEnabled() || !user) return false;
  const roles = [user.rol, ...(Array.isArray(user.roles) ? user.roles : [])].filter(Boolean);
  if (roles.includes('super_admin')) return true;
  return hasFitLiveCreatorFlag(user);
}

/**
 * Creator Fit Live (no super_admin): nav corto (solo Inicio) + home de estadísticas.
 * No expone Mi Progreso / Soporte / Mi Cuenta del consumidor D28D.
 */
export function isFitLiveCreatorShellUser(user) {
  if (!isFitLiveUiEnabled() || !user) return false;
  const roles = [user.rol, ...(Array.isArray(user.roles) ? user.roles : [])].filter(Boolean);
  if (roles.includes('super_admin')) return false;
  return hasFitLiveCreatorFlag(user);
}

/**
 * Explorar/reservar Fit Live, o abrir Studio si es creator.
 * Training-only sigue fuera del marketplace; creator (aunque sea coach) sí puede entrar a Studio.
 * El boot a Training no usa esto (sigue `isTrainingShellUser` en Dashboard).
 */
export function canAccessFitLive(user) {
  if (!isFitLiveUiEnabled() || !user) return false;
  if (canManageFitLiveStudio(user)) return true;
  if (isTrainingShellUser(user)) return false;
  return true;
}

/**
 * Fit Live es producto independiente: sin gate de ciclo/activación D28D.
 * Coach-cliente Training impago sigue bloqueado en su flujo (subscriptionAccess).
 */
export function isFitLiveAccessOpen(user) {
  return canAccessFitLive(user);
}

export function isFitLivePublicPath(pathname = '') {
  const p = String(pathname || '');
  return p === '/live' || p === '/fit-live' || p.startsWith('/live/');
}

export function markFitLiveIntent(action = 'open') {
  try {
    sessionStorage.setItem('fitLive.intent', action);
  } catch { /* ignore */ }
}

export function clearFitLiveIntent() {
  try {
    sessionStorage.removeItem('fitLive.intent');
  } catch { /* ignore */ }
}

export function consumeFitLiveIntent() {
  try {
    const v = sessionStorage.getItem('fitLive.intent');
    sessionStorage.removeItem('fitLive.intent');
    return v;
  } catch {
    return null;
  }
}
